import styled, { css } from "styled-components";
import customMedia from "../../config/breakpoints";

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  ${customMedia.lessThan("mobile")`
  align-items: center;
  justify-content: center;
  `}
`;

export const TagContainer = styled.div<{
  isActive: boolean;
  hasOneActiveTag: boolean;
}>`
  border-color: 1px
    ${({ theme, isActive }) =>
      isActive ? theme.colors.domains.orange : theme.colors.grey200};
  border-width: ${({ isActive }) => (isActive ? "4px" : "1px")};
  border-style: solid;
  padding: 16px 24px;
  border-radius: 200px;
  box-sizing: border-box;
  font-family: Aileron;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme, isActive }) =>
    isActive ? theme.colors.domains.orange : theme.colors.grey500};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    border: 4px solid ${({ theme }) => theme.colors.domains.orange};
    box-sizing: border-box;
    font-weight: 700;
  }

  ${customMedia.lessThan("mobile")`
     width:100%;
     padding: 16px 2px;
     transition: all 0s ease;
  `}

  ${({ isActive, hasOneActiveTag }) =>
    !isActive &&
    hasOneActiveTag &&
    css`
      @media (max-width: 415px) {
        display: none;
      }
    `}

  ${({ isActive, hasOneActiveTag }) =>
    isActive &&
    hasOneActiveTag &&
    css`
      @media (max-width: 415px) {
        width: 80%;
      }
    `}
`;

export const CloseButton = styled.div<{ hasOneActiveTag: boolean }>`
  align-items: center;
  background: ${({ theme }) => theme.colors.grey100};
  border-radius: 200px;
  display: flex;
  height: 48px;
  justify-content: center;
  width: 48px;

  ${({ hasOneActiveTag }) =>
    !hasOneActiveTag &&
    css`
      display: none;
    `}

  ${() =>
    css`
      @media (min-width: 415px) {
        display: none;
      }
    `}
`;
